<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M11.7778 16.1176C14.8301 16.1176 17.3163 13.7412 17.3163 10.8235V7.29412C17.3163 4.57647 15.1501 2.35294 12.3932 2.05882V2H11.1624V2.05882C8.40552 2.35294 6.23937 4.57647 6.23937 7.29412V10.8235C6.23937 13.7412 8.72552 16.1176 11.7778 16.1176ZM8.70091 4.42353V6.70588H9.93168V3.58824C10.3132 3.41176 10.7317 3.29412 11.1624 3.23529V6.70588H12.3932V3.23529C12.824 3.29412 13.2424 3.41176 13.624 3.58824V6.70588H14.8548V4.42353C15.6178 5.16471 16.0855 6.17647 16.0855 7.29412V7.88235H7.47014V7.29412C7.47014 6.17647 7.93783 5.16471 8.70091 4.42353ZM7.47014 9.05882H16.0855V10.8235C16.0855 13.0941 14.1532 14.9412 11.7778 14.9412C9.40245 14.9412 7.47014 13.0941 7.47014 10.8235V9.05882ZM19.7778 10.2353V14.0588C19.7778 16.4941 17.2917 18.4706 14.2394 18.4706H12.3932V22H11.1624V18.4706H9.31629C6.26399 18.4706 3.77783 16.4941 3.77783 14.0588V10.2353H5.0086V14.0588C5.0086 15.8471 6.94091 17.2941 9.31629 17.2941H14.2394C16.6148 17.2941 18.5471 15.8471 18.5471 14.0588V10.2353H19.7778Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
